import { LeftCircleOutlined, InboxOutlined } from "@ant-design/icons";
import { Button, Col, Row, message, Upload, UploadProps, notification, Table } from "antd";
import { useAppSelector } from "../../../redux/hooks";
import { BASE_URL } from "../../../redux/services/baseApi";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const { Dragger } = Upload;

const UploadSurveyinvoiceClaim = ({ refetch, heading, action, successMessage }: any) => {
  const navigate = useNavigate();

  const [api, contextHolder] = notification.useNotification();
  const [errorMessages, setErrorMessages] = useState<any>(null);

  const auth = useAppSelector<any>((store) => store.auth);

  const props: UploadProps = {
    name: "bookings_file",
    method: "POST",
    multiple: false,
    headers: {
      "access-token": auth?.accessToken,
      "token-type": "Bearer",
      client: auth.client,
      uid: auth.uid
    },
    action: `${BASE_URL}surveys/${action}`,
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(successMessage);
        onGoBack();
        refetch();
      } else if (status === "error" && info?.file?.response?.errors.base) {
        setErrorMessages(info?.file?.response?.errors?.base);
      } else if (status === "error" && !info?.file?.response?.errors.base) {
        message.error("Something went wrong..");
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
    onRemove(e) {
      setErrorMessages(null);
    }
  };

  const onGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      {contextHolder}
      <Row style={{ marginBottom: 20 }}>
        <Col
          sm={24}
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <h2>{heading}</h2>
          <Button onClick={onGoBack} size="middle" type="default" icon={<LeftCircleOutlined />}>
            Back
          </Button>
        </Col>
      </Row>

      <div>
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">Support for a single upload.</p>
        </Dragger>
      </div>

      <div style={{ marginTop: "20px" }}>
        {errorMessages && (
          <Table
            rowKey="message"
            dataSource={errorMessages?.map((message: any) => {
              return { message: message };
            })}
            columns={[{ dataIndex: "message", key: "message", title: "Error Message" }]}
            pagination={false}
            bordered
            scroll={{ x: 400 }}
          />
        )}
      </div>
    </>
  );
};

export default UploadSurveyinvoiceClaim;
